export default "/images/vendor/flag-icon-css/flags/4x3/cn.svg?5744860e2b32d35e322c5803b1dcf11b";